import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=7a3c7c51&scoped=true"
import script from "./Identify.vue?vue&type=script&lang=js"
export * from "./Identify.vue?vue&type=script&lang=js"
import style0 from "./Identify.vue?vue&type=style&index=0&id=7a3c7c51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c7c51",
  null
  
)

/* custom blocks */
import block0 from "./Identify.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports